import { Language } from './language';

const it = {
    code: Language.it,

	// HOME PAGE

	t_description: 'Batterista ragazza, {age} anni',
	t_close: 'Vicino',

	b_home: 'Inizio',
	b_about: 'Su di me',
	b_press: 'Premere',
	b_shows: 'Spettacoli dal vivo',
	b_soultone: 'Soultone',
	b_collision: 'Collision',
	b_language: 'Italiano',
	b_share: 'Condividere',
	b_scroll_to_top: 'Vai all\'inizio',
	b_click: 'Clic',
	b_tap: 'Premere',

	t_english: 'Inglese',
	t_spanish: 'Spagnolo',
	t_portuguese: 'Portoghese',
	t_italian: 'Italiano',
	t_french: 'Francese',
	t_german: 'Tedesco',
	t_chinese: 'Cinese',

	// SHOWS PAGE

	ClassicMetal_title: 'Metallo classico',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Presentazione della Festa dei Nonni 2024',
	StAlsGrandDay2024_description: 'Scuola Sant\'Alfonso di Seattle',

	BlackViolinConcert_title: 'Concerto di violino nero con The World Your Orchestra',
	BlackViolinConcert_description: 'Il Teatro Paramount',

	MexicanIndependenceDay2024_title: 'Celebrazione dell\'Indipendenza del Messico con l\'Orchestra Civica Ballard',
	MexicanIndependenceDay2024_description: 'Municipio di Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival dei frutti di mare Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival dei frutti di mare Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',
	
	ModernMetal_title: 'Metallo moderno',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Anteprima stagione inverno 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Metallo per capelli',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Talent Show 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Anteprima di stagione primavera 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'I Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Spettacolo di colonne sonore',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgia anni \'90',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Talent Show 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Vedi qui',

	fox_13_news_title: 'Rapporto sulle notizie di Fox 13 Seattle',
	fox_13_news_description: 'Sezione del vero nord-ovest con',

	the_daly_migs_show_interview_title: 'Intervista con The Daly Migs Show',
	the_daly_migs_show_interview_description: 'Intervista sull\'essere invitato a salire sul palco con i Godsmack',

	alizee_defan_07_02_2024_title: 'Intervista con "Alizee Defan"',
	alizee_defan_07_02_2024_description: 'Intervista esclusiva',

	jaime_mendez_news_06_26_2024_title: 'Intervista a "Jaime Mendez News"',
	jaime_mendez_news_06_26_2024_description: 'Notizie locali di Seattle in spagnolo',

	bien_informado_03_22_2023_title: 'Articolo di "Bien Informado"',
	bien_informado_03_22_2023_description: 'Articolo del sito di notizie argentino su Victoria',

	wave_potter_reaction_01_30_2023_title: 'La reazione di Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reagisce alla copertina di Victoria Lux Æterna dei Metallica',
	
	// ABOUT PAGE

	b_back: 'Torna indietro',

	t_title: 'Victoria Acosta',
	t_pronouns: '(lei)',

	b_read_more: 'Per saperne di più',
	b_read_less: 'Leggi di meno',

	t_about: `
Con le bacchette in mano e il ritmo nel sangue, Victoria Acosta, {age} anni, conquista il pubblico come una delle giovani batteriste più promettenti del momento.

Nata a El Paso, in Texas, e cresciuta a Guadalajara, in Messico, oggi Victoria vive a Seattle, dove continua a stupire con la sua straordinaria dedizione alla musica.

La sua passione per la batteria è nata all’età di quattro anni. Quando ha ricevuto il suo primo drumkit il 13 settembre 2018, tutto è cambiato. Ha iniziato i suoi studi musicali presso l’Accademia Musicalerias di Guadalajara e li ha poi proseguiti a Seattle, dimostrando un rapido progresso. Dopo una lezione di prova eccezionale alla School of Rock il 29 maggio 2022, è stata ammessa direttamente al Performers Program, saltando il programma per principianti. Da allora, Victoria ha entusiasmato il pubblico in {shows} spettacoli dal vivo con la sua energia contagiosa e una presenza scenica impressionante.

Ma il viaggio musicale di Victoria va ben oltre il palcoscenico. Ha registrato centinaia di video sui social media, creando una comunità di fan sempre più numerosa. Il 13 giugno 2024 è stata invitata come batterista ospite dal compositore italiano Alberto Rigonni per l’album Nemesis Call. Nello stesso anno ha firmato un endorsement con Soultone Cymbals il 12 settembre, e l’8 marzo 2025 è entrata a far parte del roster artistico di Collision Drumsticks—un altro traguardo importante nella sua giovane carriera.

Victoria non si limita alla batteria: ha iniziato a studiare violino in quarta elementare. Nel 2024 è entrata a far parte della World Youth Orchestra, si è esibita con il duo Black Violin al Paramount Theatre e ha debuttato come percussionista con la Ballard Civic Orchestra alla Town Hall di Seattle durante la celebrazione dell’indipendenza del Messico.

Tra i suoi numerosi riconoscimenti figurano il Gold Prize e il Fantastic Technique Award al concorso London Young Musician 2022, oltre al Annual Star Musician Award e allo Outstanding Drummer Special Award ricevuti nel 2023.

Victoria si allena ogni giorno, superando costantemente i propri limiti sia alla batteria che al violino. Con una passione inarrestabile e una creatività senza confini, non è solo una giovane promessa—è una forza della natura in piena ascesa.
	`,

	// PRESS PAGE

	t_footer: 'Tutti i diritti riservati',

	// SOULTONE: 

	b_visit_artist_page: 'Visita la mia pagina artista',

};

export default it;
